import * as Sentry from '@sentry/react'

import authFetch from './authFetch'
import { get, post } from './fetch'

import type { UserGroupConfig, Authority, SubGroup } from 'types'

export interface UserProfile {
  id: number
  businessID: string
  name: string
  email: string
  pictureURI: string
  userGroup: string
  concurID: string
  subGroups: string[]
  subGroupInfos: SubGroup[]
  trialEndDate: string
  userGroupConfig: UserGroupConfig
  authority: Authority
}

interface LoginResponse {
  loginUrl: string
}

interface sessionResponse {
  isLoggedIn: boolean
}

export const PROFILE_CACHE_ID = 'profilecacheid'
export async function getUserProfile() {
  const { userProfile } = await (get('users/profile', {
    cache: true,
    id: PROFILE_CACHE_ID,
  }) as Promise<{ userProfile: UserProfile }>)
  return userProfile
}

export interface UpdateVendorList {
  startTime: string
  updateTime: string
  updateStatus: string
}

export function getUpdateVendorList() {
  return get('users/vendor-list') as Promise<UpdateVendorList>
}

export async function updateVendorList() {
  const rtn = await post('users/vendor-list')
  return rtn.data as UpdateVendorList
}

export const login = async () => {
  return await (authFetch.get('loginUrl') as Promise<LoginResponse>)
}

export function logout() {
  return authFetch.get('logout')
}

export const getSession = async () => {
  try {
    const { isLoggedIn } = await (authFetch.get(
      'sessions/me',
    ) as Promise<sessionResponse>)
    return isLoggedIn
  } catch (error) {
    Sentry.captureException(error)
    return false
  }
}

export interface User {
  userID: number
  businessID: string
  userName: string
}
interface Params {
  subGroup?: string
}
export async function getUsers(params: Params = {}) {
  const { results } = await (get('users', { params }) as Promise<{
    results: User[]
  }>)
  return results
}
